import { API_V2, MAIN_API_ROOT, NOTIFICATIONS_ROOT } from 'app_config';

import createApiClient from './createProtectedApiClient';

export const protectedApiClient = createApiClient(MAIN_API_ROOT);
export const protectedApiClientV2 = createApiClient(API_V2);
export const notificationHubClient = createApiClient(NOTIFICATIONS_ROOT);
